import { render, staticRenderFns } from "./ApplicationViewHeader.vue?vue&type=template&id=31bc2810&scoped=true&"
import script from "./ApplicationViewHeader.vue?vue&type=script&lang=js&"
export * from "./ApplicationViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationViewHeader.vue?vue&type=style&index=0&id=31bc2810&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bc2810",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
